import React, { Component } from 'react';
import { connect } from 'react-redux';
import backhaul from '../../../assets/images/BackhaulIcon.png';
import errorIcon from '../../../assets/images/errorIcon.png';
import other from '../../../assets/images/other.png';
import router from '../../../assets/images/RouterIcon.png';
import axios from '../../../axios-local-api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

class DeviceIcon extends Component {
  state = {};

  render() {
    let displayImage;
    if (this.props.iconUrl) {
      displayImage = `url(${this.props.iconUrl})`;
    } else {
      displayImage = `url(${other})`;
    }
    switch (
      this.props.originalDevice &&
      this.props.originalDevice.deviceIconReference
    ) {
      // case undefined:
      //   displayImage = `url(${ other})`;
      //   break;
      //     case 'CAMERA':
      //       displayImage = `url(${cam})`;
      //       break;
      //     case 'GAMECONSOLE':
      //       displayImage = `url(${ game})`;
      //       break;
      //     case 'LAPTOP':
      //        displayImage = `url(${ laptop})`;
      //       break;
      //     case 'PHONE':
      //       displayImage = `url(${ mobile})`;
      //       break;
      //     case 'OTHER':
      //       displayImage = `url(${ other})`;
      //       break;
      //     case 'DESKTOP':
      //       displayImage = `url(${ pc})`;
      //       break;
      //     case 'APPLIANCE':
      //       displayImage = `url(${ plug})`;
      //       break;
      //     case 'PRINTER':
      //       displayImage = `url(${ printer})`;
      //       break;
      //     case 'STREAMING':
      //       displayImage = `url(${ remote})`;
      //       break;
      //     case 'TABLET':
      //       displayImage = `url(${ tablet})`;
      //       break;
      //     case 'THERMOSTAT':
      //       displayImage = `url(${ thermo})`;
      //       break;
      //     case 'TV':
      //       displayImage = `url(${ tv})`;
      //       break;
      //     case 'DEFAULT':
      //       displayImage = `url(${ other})`;
      //       break;
      case 'BACKHAULICON':
        displayImage = `url(${backhaul})`;
        break;
      case 'ROUTERICON':
        displayImage = `url(${router})`;
        break;
      case 'ERRORICON':
        displayImage = `url(${errorIcon})`;
        break;
      default:
    }
    // }
    return (
      <div
       id = 'DeviceIcon'
        style={{
          height: this.props.size,
          width: this.props.size,
          backgroundImage: displayImage,
          backgroundSize: '' + this.props.size + 'px ' + this.props.size + 'px',
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(DeviceIcon, axios));
